import { IAppState } from '../../redux';

export function selectIsPublishToHiddenBase(state: IAppState): boolean {
  const {
    publishAvailable: { isPublishToHiddenBase },
  } = state;

  return isPublishToHiddenBase;
}
